import { Collapse } from 'antd';
import EFPicture from 'elem/compCommon/EFPicture';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination } from 'swiper';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';

export default function K() {
    const { useLang, Link, useRouter, useState } = useGlobal();
    const { locale } = useRouter();
    const { t } = useLang('RV');
    const [active, setActive] = useState(1);

    const lists = [
        {
            title: t('K_card1_title'),
            desc: t('K_card1_desc'),
            link: t('K_card1_link'),
        },
        {
            title: t('K_card2_title'),
            desc: t('K_card2_desc'),
            link: t('K_card2_link'),
        },
        {
            title: t('K_card3_title'),
            desc: t('K_card3_desc'),
            link: t('K_card3_link'),
        },
        {
            title: t('K_card4_title'),
            desc: t('K_card4_desc'),
            link: t('K_card4_link'),
        },
    ];

    const IMGS = [
        'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1717080810104/11_1.jpg',
        locale === 'au'
            ? 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1717080855463/11_2.jpg'
            : 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1717080819751/11_2.jpg',
        'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1717080834236/11_3.jpg',
        'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1717080844302/11_4.jpg',
    ];

    const handleCollapseChange = (k: string | undefined) => {
        setActive(k ? Number(k) + 1 : 1);
    };

    return (
        <div id="RV-K" className={`RV-K RV-box ${css['RV-K']}`}>
            <div className="info-box">
                <p className="title">{t('K_title')}</p>
            </div>
            <div className="collapse-box">
                <div className="img-box">
                    <EFPicture src={IMGS[active - 1]} alt={t(`K_card${active}_title`)} />
                </div>
                <Collapse
                    ghost={true}
                    className="collapse-lists"
                    defaultActiveKey={0}
                    accordion={true}
                    onChange={handleCollapseChange}
                    expandIcon={({ isActive }: any) => (
                        <svg
                            className={`collapse-icon ${isActive ? 'active' : ''}`}
                            xmlns="http://www.w3.org/2000/svg"
                            width="24"
                            height="24"
                            viewBox="0 0 25 24"
                            fill="none"
                        >
                            <path d="M17.5 15L12.5 10L7.5 15" stroke="black" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                        </svg>
                    )}
                    expandIconPosition="right"
                >
                    {lists?.map((list: any, k: number) => (
                        <Collapse.Panel className="list-title" key={k} header={list.title}>
                            <p className="list-desc">{list.desc}</p>
                            <Link
                                href={list.link}
                                target="_blank"
                                className="list-link"
                                dataLayer={{
                                    event: 'uaEvent',
                                    event_name: 'select_news',
                                    title_name: list.title,
                                    button_name: t('K_more'),
                                }}
                            >
                                <span>{t('K_more')}</span>
                                <svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 17 17" fill="none">
                                    <path
                                        d="M6.75651 2.85889L12.0898 8.19222L6.75651 13.5256"
                                        stroke="#3F68E0"
                                        strokeWidth="1.4"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                    />
                                </svg>
                            </Link>
                        </Collapse.Panel>
                    ))}
                </Collapse>
            </div>
            <Swiper className="cards swiper-box" modules={[Pagination]} spaceBetween={0} slidesPerView={'auto'} initialSlide={0} pagination={true}>
                {lists?.map((card: any, k: number) => (
                    <SwiperSlide className="swiper-item" key={k}>
                        <div className="card-img">
                            <EFPicture src={IMGS[k]} alt={card?.text} />
                        </div>
                        <div className="card-info">
                            <p className="card-title">{card.title}</p>
                            <p className="card-desc">{card.desc}</p>
                            <Link
                                href={card.link}
                                target="_blank"
                                className="card-link"
                                dataLayer={{
                                    event: 'uaEvent',
                                    event_name: 'select_news',
                                    title_name: card.title,
                                    button_name: t('K_more'),
                                }}
                            >
                                <span>{t('K_more')}</span>
                                <svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 17 17" fill="none">
                                    <path
                                        d="M6.75651 2.85889L12.0898 8.19222L6.75651 13.5256"
                                        stroke="#3F68E0"
                                        strokeWidth="1.4"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                    />
                                </svg>
                            </Link>
                        </div>
                    </SwiperSlide>
                ))}
            </Swiper>
        </div>
    );
}
